import { render, staticRenderFns } from "./SubjectLayout.vue?vue&type=template&id=06236d7b&scoped=true&"
import script from "./SubjectLayout.vue?vue&type=script&lang=js&"
export * from "./SubjectLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubjectLayout.vue?vue&type=style&index=0&id=06236d7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06236d7b",
  null
  
)

export default component.exports